import { Grid, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import {FormAutocomplete, FormTextField, FormDatePicker} from "../../../common/form-fields-wrappers";
import {IRaDetailView} from "../../../models/models";

const BillingOwnerInfoPerson = ({boType}: {boType: 'first' | 'second'}) => {
    const {t} = useTranslation(['network', 'translation']);
    const raDetailForm = useFormContext<IRaDetailView>();
    const theme = useTheme();
    
    return (
        <Grid container columnSpacing={2} sx={{mb: theme.spacing(4)}}>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.customerId`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.bpCodeSap")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.firstName`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.firstName")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.lastName`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.lastName")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.fiscalCode`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.fiscalCode")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.gender`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.gender")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.code ? t(opt.code) : ''}
                    isOptionEqualToValue={(_option, value) => value?.code}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormDatePicker<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.birthDate`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.birthDate")}
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.birthNation`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.birthNation")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(_option, value) => value?.code}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.birthPlace`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.birthPlace")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(_option, value) => value?.code}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.countryResidence`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.countryResidence")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(_option, value) => value?.code}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.provinceResidence`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.provinceResidence")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(_option, value) => value?.code}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.cityResidence`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.cityResidence")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(option, value) => option?.code === value?.code}
                    fullWidth
                    disabled
                />
            </Grid>

            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.address`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.address")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.streetNumber`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.streetNumber")}
                    disabled
                />
            </Grid>

            <Grid item xs={2} md={1} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.prefix`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.prefix")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(_option, value) => value?.code+value.description}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={4} md={2} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.mobile`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.mobile")}
                    fullWidth
                    disabled
                />
            </Grid>

            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.firstEmail`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.firstEmail")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.secondEmail`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.secondEmail")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.certifiedEmail`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.certifiedEmail")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingCountry`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.billingCountry")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(option, value) => option?.code === value?.code}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingProvince`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.billingProvince")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(option, value) => option?.code === value?.code}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingCity`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.billingCity")}
                    options={[]}
                    getOptionLabel={(opt) => !!opt?.description ? t(opt.description) : ''}
                    isOptionEqualToValue={(option, value) => option?.code === value?.code}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingAddress`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.billingAddress")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingStreetNumber`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.person.billingStreetNumber")}
                    disabled
                />
            </Grid>
        </Grid>
    )
};

export default BillingOwnerInfoPerson;